<template>
  <div class="link-form">
    <modal-header>
      Link &#8729;

      <div class="dateCont">
        <v-date-picker class="scheduledTime" v-model="createdAt" mode="dateTime" is24hr is-dark color="green" :model-config="{type: 'string', mask: 'iso'}">
          <template v-slot="{ inputValue, inputEvents }">
            <input
              :value="createdAt ? inputValue : 'Now'"
              v-on="inputEvents"
            />
          </template>
        </v-date-picker>

        <button v-if="createdAt" class="resetDate" @click="createdAt = ''">Reset date to now</button>
      </div>
    </modal-header>
       <div class="link-form__form">
      <form enctype="multipart/form-data">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            :class="{ 'input-error': error.url }"
            id="url"
            aria-describedby="enter url here"
            placeholder="URL (Required)"
            v-model="url"
            @focus="error.url = ''"
          />
          <span class="error" v-if="error.url">{{ error.url }}</span>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            :class="{ 'input-error': error.title }"
            placeholder="Title (Required)"
            v-model="title"
            @focus="error.title = ''"
          />
          <span class="error" v-if="error.title">{{ error.title }}</span>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            :class="{ 'input-error': error.description }"
            id="description"
            placeholder="Description (300 chars max)"
            v-model="description"
            @focus="error.description = ''"
          ></textarea>
          <span class="error" v-if="error.description">{{ error.description }}</span>
        </div>
        <div class="form-group image-container" :style="imgStyle">
          <div v-if="!imageUrl" class="image-uploading-div" :class="{ highlight: highlight }"
            @dragenter="handleDragDrop" @dragleave="handleDragDrop" @dragover.prevent @drop="handleDragDrop"
          >
            <input
              type="file"
              class="form-control image-input"
              ref="imageFileUpload"
              accept="image/*"
              @change="handleFileChange"
            />

            <img src="@/assets/global-icons/upload-arrow.svg" class="drag-drop-upload-image" />
            <span class="first-upload-line">Drag and drop your cover image here</span>
            <button type="button" class="upload-button" @click="$refs.imageFileUpload.click()">
              Select a file
            </button>
          </div>
          <button v-else type="button" class="delete-image" @click="imageUrl = ''">Change Image</button>
        </div>

      </form>
    </div>
    <button type="button" class="btn submit-button margin-right" @submit.prevent @click="submitForm()">
      {{ data ? 'Update' : 'Add' }}
    </button>
  </div>
</template>

<script>
import { validateURL, processMediaURL } from '@/functions/utility.js';

import ModalHeader from '@/framework/modals/components/newModalHeader.vue'

import { mapActions } from 'vuex';

export default {
  name: 'LinkForm',
  components: { ModalHeader},
  props: {
    data: { type: Object, default: null },
  },
  data() {
    return {
      url: '',
      title: '',
      description: '',
      imageUrl: '',
      createdAt: '',
      error: {
        title: '',
        url: '',
        description: ''
      },
      highlight: false,
    };
  },
  computed: {
    imgStyle: vm => vm.imageUrl ? {background: `center / cover no-repeat url('${processMediaURL(vm.imageUrl)}')`} : ''
  },
  methods: {
    ...mapActions([
      'api/genericHandler',
      'library/load',
      'modal/close',
      'analytics/createContent',
      'analytics/editContent',
      'popups/show/error/custom',
      'popups/show/error/uploading',
      'popups/show/success/creating',
      'popups/show/success/updating'
    ]),
    api(name, ...input){
      return this['api/genericHandler']([
        'media/'+name,
        ...input
      ])
    },
    close(){
      this['modal/close']();
    },
    async handleDragDrop(e){
      e.preventDefault();
      e.stopPropagation();

      switch(e.type){
        case 'dragenter': this.highlight = true; break;

        case 'dragleave':
        case 'drop': this.highlight = false; break;
      }

      if(e.type === 'drop') {
        this.handleUpload(e.dataTransfer.files[0])
      }
    },
    handleFileChange(e) {
      this.handleUpload(e.target.files[0])
    },
    async handleUpload(file) {
      let res = await this.api('uploadImage', [file, 'mediaItemImage'], () => this['popups/show/error/uploading']('your Image'))
      if(!res?.success) return

      this.imageUrl = res.success
    },
    async submitForm() {
      if(!this.title) this.error.title = 'Link must have a title'
      if(!validateURL(this.url)) this.error.url = 'Invalid URL'
      if(this.description.length > 300) this.error.description = `Description too long: ${this.description.length - 300} chars over the limit.`

      for(let k in this.error) if(this.error[k]) return

      if (!this.createdAt) this.createdAt = new Date().toISOString()

      let res = await this.api(
        'library/admin'+(this.data ? 'Update' : 'Post'),
        [this.title, this.description, this.url, this.imageUrl, this.createdAt, this.data?.id],
        () => this['popups/show/error/custom'](`${this.data ? 'updating' : 'creating'} item`)
      )
      if(this.data) this['analytics/editContent']([this.title, this.description, this.url, this.imageUrl, this.createdAt])
      else this['analytics/createContent']([this.title, this.description, this.url, this.imageUrl, this.createdAt, this.data?.id])


      if(res?.success) {
        if(this.data) this['popups/show/success/updating']('Link')
        else this['popups/show/success/creating']('Link')
        this['library/load']()
        this.close()
      }
    }
  },
  mounted() {
    // k for key
    if(this.data) for(let k of ['title', 'description', 'url', 'imageUrl', 'createdAt']){
      this[k] = this.data[k]
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '~@/scss/components/modals/link_form.scss';
</style>
